import React from 'react'
import { connect } from 'react-redux'
// import Loading from '../Shared/Loading'
import { toastr } from 'react-redux-toastr'
import LoadingBar from '../Shared/LoadingBar'
// import { Line } from 'rc-progress'
import { history } from '../../_helpers'
import { examService } from '../../_services/exam.service'
// import "react-circular-progressbar/dist/styles.css"
// import NumberFormat from 'react-number-format'
import examStatuses from '../../_constants/examStatuses'
import { FaPlay } from 'react-icons/fa'
import scrollToComponent from 'react-scroll-to-component'
import { AiOutlineLoading, AiOutlineSave } from 'react-icons/ai'
import moment from 'moment-jalaali'
import { config } from '../../config'
const base_url = config.apiBaseUrl

function formatDate(e) {
  if (e !== '0001-01-01T00:00:00') {
    const momentValue = moment(e.split('T')[0], 'YYYY-MM-DD HH:mm')
    if (momentValue.isValid()) {
      return momentValue.format('jYYYY/jMM/jDD')
    }
  }
}
function formatTime(e) {
  if (e !== '0001-01-01T00:00:00') {
    const momentValue = moment(e.split('T')[1], 'HH:mm')
    if (momentValue.isValid()) {
      return momentValue.format('HH:mm')
    }
  }
}

class MembersExam extends React.Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      loading: true,
      data: [],
      selected: '',
      key: 0
    }
  }

  componentWillMount = () => {
    LoadingBar(true)

    this.getData()
  }

  getData() {
    examService
      .getAll(this.props.user.id)
      .then(res => {
        // console.log(res.data)
        var data = res.data
        this.setState(
          { data: data, loading: false, newExamLoading: false },
          () => {
            LoadingBar(false)
          }
        )
      })
      .catch(error => {
        this.handleError(error)
      })
  }

  handleError(error) {
    this.setState({ loading: false })
    // toastr.warning('خطا', error.response.data.message);
    LoadingBar(false)
    // console.log(error);
  }

  handleMovieSelect = item => {
    this.setState({ selected: item, key: this.state.key + 1 }, () => {
      scrollToComponent(this.refs.playerContainer)
    })
  }

  handleNewExamClick = () => {
    this.setState({ newExamLoading: true })

    examService
      .createExam(this.props.user.id)
      .then(res => {
        // console.log(res.data)
        var data = res.data
        this.setState(
          { data: this.state.data.concat(data), newExamLoading: false },
          () => {
            LoadingBar(false)

            // examService.paid(data.id)
            //   .then((res) => {
            //     console.log(res.data)

            //   })
            //   .catch((error) => {
            //     this.handleError(error)
            //   })

            this.getData()
          }
        )
      })
      .catch(error => {
        if (error.response.status === 402) {
          // console.log(error.response.data.message);
        }
        this.setState({ newExamLoading: false })
        this.handleError(error)
      })
  }

  handleStartPayment = (e, id) => {
    e.preventDefault()

    this.setState({ examTransferToBankLoading: id })

    window.location.assign(base_url + 'bank/examTransferToBank/' + id)
  }

  handleStartExam = (e, id) => {
    e.preventDefault()

    history.push('/member/startExam/' + id)

    // this.setState({ examTransferToBankLoading: id })

    // window.location.assign(base_url + 'bank/examTransferToBank/' + id)
  }

  render() {
    const {
      data,
      selected,
      loading,
      newExamLoading,
      examTransferToBankLoading
    } = this.state
    return (
      <div className="movies">
        <div className="row">
          <div className="col-md-10 col-md-offset-1">
            <a
              className="btn btn-success btn-icon-rught mb-15"
              onClick={() => !newExamLoading && this.handleNewExamClick()}>
              {newExamLoading ? (
                <AiOutlineLoading className="mdi-spin" size="18px" />
              ) : (
                ''
              )}
              درخواست آزمون جدید
            </a>
            <table className="table table-striped table-hover exam-table text-center table-bordered table-canvas">
              <thead>
                <tr>
                  <th>#</th>
                  <th>تاریخ</th>
                  <th>ساعت شروع</th>
                  <th>وضعیت</th>
                  <th style={{ width: 220 }}>پرداخت آنلاین</th>
                  <th>شروع آزمون</th>
                </tr>
              </thead>
              <tbody>
                {data && data.length > 0 ? (
                  data.map((item, index) => (
                    <tr key={'exam-' + item.id + '-' + index}>
                      <td>{index + 1}</td>
                      <td>{formatDate(item.createDateTime)}</td>
                      <td>{formatTime(item.createDateTime)}</td>
                      <td>
                        <div className="exam-result-col">
                          <span>
                            {examStatuses.filter(
                              el => el.value === item.examStatus
                            )[0] &&
                              examStatuses.filter(
                                el => el.value === item.examStatus
                              )[0].name}
                          </span>
                          {item.result && item.result.length > 0 ? (
                            <div className="currect-questions">
                              <span>
                                جواب صحیح:{' '}
                                {item.result[0] && item.result[0].corrects}
                              </span>
                              <span>
                                جواب غلط:{' '}
                                {item.result[0] && item.result[0].incorrects}
                              </span>
                            </div>
                          ) : (
                            ''
                          )}
                        </div>
                      </td>
                      <td>
                        <button
                          className="btn btn-success btn-icon-rught "
                          disabled={item.examStatus !== 4}
                          onClick={e => this.handleStartPayment(e, item.id)}>
                          {examTransferToBankLoading === item.id ? (
                            <span>
                              <i className="mdi  mdi-spin mdi-loading" /> در حال
                              اتصال به درگاه بانک
                            </span>
                          ) : (
                            <span>پرداخت آنلاین</span>
                          )}
                        </button>
                      </td>
                      <td>
                        {item.examStatus === 5 && (
                          <button
                            className="btn btn-info btn-icon-rught "
                            disabled={item.examStatus !== 5}
                            onClick={e => this.handleStartExam(e, item.id)}>
                            {examTransferToBankLoading === item.id ? (
                              <span>
                                <i className="mdi  mdi-spin mdi-loading" /> در
                                حال اتصال به درگاه بانک
                              </span>
                            ) : (
                              <span>شروع آزمون</span>
                            )}
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="7"
                      className="text-center pb-30 pt-30 td-white">
                      موردی برای نمایش وجود ندارد
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {loading ? (
          <div className="loading-container">
            <AiOutlineLoading
              className="mdi-spin"
              size="32px"
              color="#5079f7"
            />
          </div>
        ) : (
          <div className="row">
            <div className="col-md-10 col-md-offset-1">
              {data &&
                data.map((item, index) => (
                  <ul key={'title-' + item.id} className="movies-titles">
                    <li>
                      <h4>{item.name}</h4>
                      {item.movies && (
                        <ul className="movies-list">
                          {item.movies.map((movie, mIndex) => (
                            <li
                              key={'movie-' + movie.id}
                              className={
                                selected && selected.id === movie.id
                                  ? 'movie-item selected'
                                  : 'movie-item'
                              }>
                              <div>{movie.name}</div>
                              <div>
                                <h5>{movie.duration}</h5>
                                <a
                                  className="btn btn-play"
                                  onClick={() => this.handleMovieSelect(movie)}>
                                  <FaPlay color="#fff" size="24px" />
                                </a>
                              </div>
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  </ul>
                ))}
            </div>
          </div>
        )}
      </div>
    )
  }
}

function mapStateToProps(state) {
  const { users, authentication } = state
  const { user } = authentication
  return {
    user,
    users
  }
}

const connectedMembersExam = connect(mapStateToProps)(MembersExam)
export { connectedMembersExam as MembersExam }
